//
// InputController.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import ClosetObject from "./ClosetObject";
import "./lib";
import "./BaseView";

var InputController = createModule("commons::InputController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        handleBlur: [0],
        handleMouseEnter: [0],
        handleMouseWheel: [2,4,4,4,4,4],
        handleMouseLeave: [0],
        handlePan: [0,4,4,4,4,4],
        handleTap: [0,4,4,4,4],
        handleMouseDoubleClick: [0,4,4,2],
        handleLongPress: [0,4,4,4,4],
        handlePointerHover: [0,4,4],
        handleMouseDown: [0,4,4,4,4,2,2],
        handleFocus: [0],
        setView: [0,1],
        handleMouseMove: [0,4,4,4,4,2,2],
        handleMouseUp: [0,4,4,4,4,2,2],
        getView: [1],
        handlePinch: [2,4,4,4,4,4,4,5,5,4],
    },
    {
        _create: [4],
    },
    ,
]);
export default InputController;
